import React, { useEffect, useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import axios from 'axios';
import * as Yup from 'yup';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import { Grid } from '@material-ui/core';
import { Formik, Field, FieldArray } from 'formik';
import { CommonConfig } from '../../config/common-config';
import LoaderPopUp from '../../components/loaderpopup/loader';
import SuccessPopUp from '../../components/loaderpopup/success';
import ErrorPopUp from '../../components/loaderpopup/error';
import { userType } from '../../config/usertypeValue';
import TabList from '../../components/checklistTab/tabList';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
        minHeight: '300px',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        color: '#727272',
        fontSize: '20px',
        fontFamily: 'Rubik',
        fontWeight: '500',
        marginBottom: '20px',
    },
    pos: {
        marginBottom: 12,
    },
    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
    },
    inlinebutton: {
        padding: '0',
        margin: '0',
        '& li': {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '15px',
        },
    },
}));

export default function RequestInvoice(props) {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch({});
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantName = tennantDetails && tennantDetails.tennantName;
    const [state, setState] = React.useState({
        checkedA: true,
    });
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const [checklist, setChecklist] = useState('');
    const [statusFlag, setStatusFlag] = useState(true);
    const checklistValues = checklist.checklistJson;
    const checklist1 = checklistValues && checklistValues.checklistL1;
    const checklist1que = checklist1 && checklist1.questions;
    const statusID = checklist && checklist.currentStage && checklist.currentStage.id;
    const dbname = tennantDetails && tennantDetails.tennantName;
    const [TAXFoldernameTaxPath, setTAXFoldernameTaxPath] = useState('');
    const [FileComputationDoc, setFileComputationDoc] = useState('');
    const [ITRFoldername, setITRFoldername] = useState('');

    const handleNavigate = (event) => {
        history.push({
            pathname: '/menu/openservice',
        });
    };

    const initialValues = {};

    initialValues.invoiceList = [{
        particulars: '',
        amount: '',
        description: '',
    }];

    const validationSchema = Yup.object().shape({
        invoiceList: Yup.array().of(
            Yup.object().shape({
                particulars: Yup.string()
                    .nullable()
                    .required('Required Field'),
                amount: Yup.string()
                    .nullable()
                    .matches(/^[0-9\,]+$/, 'Please Enter digits only')
                    .required('Required Field'),
                // description: Yup.string()
                // .nullable()
                // .required('Required Field'),
            })
        ),
    });


    //append comma for amount textfield
    const handleStateChange = (e) => {
        const {
            target: { value }
        } = e;
        if (value.length && !isNaN(parseFloat(value))) {
            const IndianCur = new Intl.NumberFormat("en-IN").format(parseFloat(value.replace(/,/g, '')));
            e.target.value = IndianCur;
            //console.log("Indian Currency",e.target.value);
        } else {
            e.target.value = value;
        }
    };
    // const handleStateChange = (e) => {
    //     const {
    //         target: { value }
    //     } = e;
    //     if (value && !isNaN(parseFloat(value))) {
    //         e.target.value = parseInt(value.replace(/,/g, '')).toLocaleString();
    //     }
    // };


    useEffect(() => {
        // if (statusFlag) {
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${tennantnameValue === 'Advith' ? tennantnameValue : imcNameSelected}/${serviceIdValue}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response && response.data) {
                    setChecklist(response.data);
                }
            })
            .catch((error) => { });


        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/by-serviceId/${dbname}/${serviceIdValue}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setTAXFoldernameTaxPath(response.data.taxChalanOrAcknowledgement);
                setFileComputationDoc(response.data.finalComputationDocument);
                setITRFoldername(response.data.itrAcknowledgement);
            })
            .catch(() => { });
        if (userType.statusFlag) {
            ////console.log('userType.statusFlag', userType.statusFlag)
            // getInitialStage();
        }
        // }
        userType.value = '';
    }, [props, bearerToken, statusID, tennantnameValue]);

    const handleSubmit = (values) => {

        setShowLoader(true);
        let tempArr = [];
        values.invoiceList.filter((ele, i) => {
            let temp = {
                "particularsText": ele.particulars,
                "amountForInvoice": ele.amount,
                "descriptionForInvoice": ele.description,
            }
            tempArr.push(temp);
        })
        //console.log('values', tempArr)
        const data = {
            serviceId: serviceIdValue,
            remarks: 'Remarks',
            finalDocumentAndReports: {
                finalComputationDocument: FileComputationDoc,
                itrAcknowledgement: ITRFoldername,
                taxChalanOrAcknowledgement: TAXFoldernameTaxPath,
                transferToAccount: false,
                payonline: true,
                stage: 'finalDocumentAndReports',
                // descriptionForInvoice: '',
                // amountForInvoice: '',
                particulars: tempArr,
                reports: 'Structure is not finalized',
            },
        };

        //console.log('data:', data)
        axios
            .put(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/request-invoice/${tennantName}`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data === 'SUCCESS') {
                    setShowLoader(false);
                    setSuccessPop(true);
                    setTimeout(() => {
                        history.push({
                            pathname: '/menu/openservice',
                        });
                    }, 3000);

                }
            })
            .catch((error) => {
                const errResult = error.response;
                if (errResult.data) {
                    setShowLoader(false);
                    setErrorPop(true);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                    setErrorMsgGenerateRecceipt(errResult.data.message);
                }
            });
    };

    const getInitialStage = () => {
        ////console.log('userType,statusID', usertype, statusID)
        // setStatusId(checklist.currentStage.id);
        if (statusID === 2 && usertype === 'Ultimate Client') {
            userType.value = 'L1 Checklist';
            navigateChecklist('/menu/checkListUltimate', 'L1 Checklist');
        }
        if (statusID === 4 && usertype === 'ITeC Team') {
            userType.value = 'L1 CRC Confirmed';
            navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed');
        }
        if (statusID === 5 && usertype === 'ITeC AM and above') {
            userType.value = 'L1 AM Confirmed';
            navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed');
        }
        if (statusID === 6 && usertype === 'Ultimate Client') {
            userType.value = 'L2 Checklist';
            navigateChecklist('/menu/checkListUltimate', 'L2 Checklist');
        }
        if (statusID === 8 && usertype === 'ITeC Team') {
            userType.value = 'L2 CRC Confirmed';
            navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed');
        }
        if (statusID === 10 && (usertype === 'EM' || usertype === "Other employee users")) {
            userType.value = 'EM Confirmed';
            navigateChecklist('/menu/crc-checklist', 'EM Confirmed');
        }
        if (statusID === 12 && usertype === 'ITeC Team') {
            userType.value = 'Detailed Analysis';
            navigateChecklist('itec-detail-analysis-crc', 'Detailed Analysis');
        }
        if (statusID === 15 && usertype === 'ITeC AM and above') {
            userType.value = 'Detailed Analysis';
            navigateChecklist('/menu/itec-detail-analysis-am', 'Detailed Analysis');
        }
        if (statusID === 14 && (usertype === 'EM' || usertype === "Other employee users")) {
            userType.value = 'Detailed Analysis';
            navigateChecklist('/menu/detail-analysis', 'Detailed Analysis');
        }
        if (statusID === 13 && usertype === "Other employee users") {
            userType.value = 'Detailed Analysis';
            navigateChecklist('/menu/detail-analysis', 'Detailed Analysis');
        }
        if ((statusID === 16 || statusID === 18) && usertype === 'EM') {
            userType.value = 'Draft Statements';
            navigateChecklist('/menu/imc-draft-document', 'Draft Statements');
        }
        if (statusID === 17 && usertype === 'Ultimate Client') {
            userType.value = 'Draft Statements';
            navigateChecklist('/menu/client-draft-document', 'Draft Statements');
        }
        if (statusID === 19 && (usertype === 'EM' || usertype === "Other employee users")) {
            userType.value = 'Tax Payment and Filing';
            navigateChecklist('/menu/imc-tax-payment', 'Final Statement');
        }
        if (statusID === 20 && usertype === 'Ultimate Client') {
            userType.value = 'Tax Payment and Filing';
            navigateChecklist('/menu/client-tax-payment', 'Tax Payment and Filing');
        }
        if (statusID === 21 && (usertype === 'EM' || usertype === "Other employee users")) {
            userType.value = 'Tax Payment and Filing';
            navigateChecklist('/menu/imc-final-doc-approval', 'Tax Payment and Filing');
        }
        if (statusID === 22 && (usertype === 'EM' || usertype === "Other employee users")) {
            userType.value = 'Reports';
            navigateChecklist('/menu/imc-reports', 'Reports');
        }
    }

    const navigateChecklist = (path, typeValue) => {
        userType.statusFlag = false;
        userType.value = typeValue;
        history.push(path);
    }

    const navigateBack = () => {
        history.push({
            pathname: '/menu/openservice',
        });
    }

    return (
        <div>
            <div>
                <div className="stage-indicator">
                    <ul>
                        {statusID === 2 && usertype === 'Ultimate Client' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className="activetab">L1 Checklist</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 4 && usertype === 'ITeC Team' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className="activetab">L1 CRC Confirmed</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 5 && usertype === 'ITeC AM and above' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className="activetab">L1 AM Confirmed</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 6 && usertype === 'Ultimate Client' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li> */}
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className="activetab">L2 Checklist</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 8 && usertype === 'ITeC Team' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', '.L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className="activetab">L2 CRC Confirmed</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 10 && (usertype === 'EM' || usertype === "Other employee users") ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className="activetab">EM Confirmed</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 12 && usertype === 'ITeC Team' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/itec-detail-analysis-crc', 'Detailed Analysis')} className="activetab">Detailed Analysis</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 15 && usertype === 'ITeC AM and above' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/itec-detail-analysis-am', 'Detailed Analysis')} className="activetab">Detailed Analysis</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 14 && (usertype === 'EM' || usertype === "Other employee users") ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis', 'Detailed Analysis')} className="activetab">Detailed Analysis</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 13 && usertype === "Other employee users" ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis', 'Detailed Analysis')} className="activetab">Detailed Analysis</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {(statusID === 16 || statusID === 18) && (usertype === 'EM' || usertype === "Other employee users") ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li>
                                <li onClick={() => navigateChecklist('/menu/imc-draft-document', 'Draft Statements')} className="activetab">Draft Statements</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 17 && usertype === 'Ultimate Client' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li> */}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li> */}
                                <li onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')} className="activetab">Draft Statements</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 19 && (usertype === 'EM' || usertype === "Other employee users") ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li>
                                <li onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li>
                                <li onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')} className="activetab">Final Statement</li>
                                {/* <li onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Tax Payment and Filing')} className="activetab">Tax Payment and Filing</li> */}
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 20 && usertype === 'Ultimate Client' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li> */}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li> */}
                                <li onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li>
                                <li onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')} className={userType.value === 'Final Statement' ? 'active' : ''}>Final Statement</li>
                                <li onClick={() => navigateChecklist('/menu/client-tax-payment', 'Tax Payment and Filing')} className="activetab">Tax Payment and Filing</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 21 && (usertype === 'EM' || usertype === "Other employee users") ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li>
                                <li onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li>
                                <li onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')} className={userType.value === 'Final Statement' ? 'active' : ''}>Final Statement</li>
                                <li onClick={() => navigateChecklist('/menu/imc-final-doc-approval', 'Tax Payment and Filing')} className="activetab">Tax Payment and Filing</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 22 && (usertype === 'EM' || usertype === "Other employee users") ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li>
                                <li onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li>
                                <li onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')} className={userType.value === 'Final Statement' ? 'active' : ''}>Final Statement</li>
                                <li onClick={() => navigateChecklist('/menu/imc-final-doc-approval', 'Tax Payment and Filing')} className={userType.value === 'Tax Payment and Filing' ? 'active' : ''}>Tax Payment and Filing</li>
                                <li onClick={() => navigateChecklist('/menu/imc-reports', 'Reports')} className={userType.value === 'Reports' ? 'active' : ''}>Reports</li>
                                <li onClick={() => navigateChecklist('/menu/request-invoice', 'Request Invoice')} className="activetab">Request Invoice</li>
                            </ul>
                        ) : (
                                ''
                            )}
                    </ul>
                </div>
            </div>





            {showLoader ? (<LoaderPopUp showLoader={showLoader} />) : null}
            {successpop ? (<SuccessPopUp open={successpop} showSuccess={successpop} title="Invoice request submitted successfully" />) : null}
            {errorpop ? (<ErrorPopUp open={errorpop} showError={errorpop} title={errorMsgGenerateRecceipt} />) : null}

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => handleSubmit(values)}
                enableReinitialize
            >
                {(formik) => {
                    return (
                        <form className="itecform" onSubmit={formik.handleSubmit}>
                            <Card className={classes.root}>
                                <CardContent>
                                    <Grid container xs={12} sm={12} spacing={3} className="main-container">

                                        <Grid container spacing={3} className="main-container">
                                            <FieldArray name="invoiceList">
                                                {(fieldArrayProps) => {
                                                    const { push, remove, form } = fieldArrayProps;
                                                    const { values } = form;
                                                    const { invoiceList } = values;
                                                    let key = 0;

                                                    return (
                                                        <>
                                                            {invoiceList.map((item, invoiceindex) => {
                                                                key++;
                                                                return (
                                                                    <Fragment key={key}>
                                                                        {invoiceindex > 0 && (
                                                                            <div className="field-divider">
                                                                                {' '}
                                                                                <hr />
                                                                            </div>
                                                                        )}
                                                                        <Grid item xs={12} sm={6}>
                                                                            <FormControl fullWidth className={classes.margin}>
                                                                                <InputLabel htmlFor="bank-name" shrink>
                                                                                    Particular <span style={{ color: "#ff0a047a" }}>*</span>
                                                                                </InputLabel>
                                                                                <Field name={`invoiceList[${invoiceindex}].particulars`}>
                                                                                    {(fieldProps) => {
                                                                                        const { field, meta } = fieldProps;

                                                                                        return (
                                                                                            <>
                                                                                                <Input
                                                                                                    className={classes.bottomLine}
                                                                                                    id="particulars"
                                                                                                    placeholder="Enter Particular"
                                                                                                    name="particulars"
                                                                                                    disabled={usertype === "Other employee users"}

                                                                                                    {...field}
                                                                                                />
                                                                                                {meta.touched && meta.error ? (
                                                                                                    <span className="itec-validationError">
                                                                                                        {meta.error}
                                                                                                    </span>
                                                                                                ) : null}
                                                                                            </>
                                                                                        );
                                                                                    }}
                                                                                </Field>
                                                                            </FormControl>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={6}>
                                                                            <FormControl fullWidth className={classes.margin}>
                                                                                <InputLabel htmlFor="bank-name" shrink>
                                                                                    Amount <span style={{ color: "#ff0a047a" }}>*</span>
                                                                                </InputLabel>
                                                                                <Field name={`invoiceList[${invoiceindex}].amount`}>
                                                                                    {(fieldProps) => {
                                                                                        const { field, meta } = fieldProps;

                                                                                        return (
                                                                                            <>
                                                                                                <Input
                                                                                                    className={classes.bottomLine}
                                                                                                    onInput={(e) => handleStateChange(e)}
                                                                                                    id="amount"
                                                                                                    placeholder="Enter Amount"
                                                                                                    name="amount"
                                                                                                    disabled={usertype === "Other employee users"}

                                                                                                    {...field}
                                                                                                />
                                                                                                {meta.touched && meta.error ? (
                                                                                                    <span className="itec-validationError">
                                                                                                        {meta.error}
                                                                                                    </span>
                                                                                                ) : null}
                                                                                            </>
                                                                                        );
                                                                                    }}
                                                                                </Field>
                                                                            </FormControl>
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={6}>
                                                                            <FormControl fullWidth className={classes.margin}>
                                                                                <InputLabel htmlFor="bank-name" shrink>
                                                                                    Description
                                                                                </InputLabel>
                                                                                <Field
                                                                                    name={`invoiceList[${invoiceindex}].description`}>
                                                                                    {(fieldProps) => {
                                                                                        const { field, meta } = fieldProps;

                                                                                        return (
                                                                                            <>
                                                                                                <Input
                                                                                                    className={classes.bottomLine}
                                                                                                    id="description"
                                                                                                    placeholder="Enter Description"
                                                                                                    name="description"
                                                                                                    disabled={usertype === "Other employee users"}

                                                                                                    {...field}
                                                                                                />
                                                                                                {meta.touched && meta.error ? (
                                                                                                    <span className="itec-validationError">
                                                                                                        {meta.error}
                                                                                                    </span>
                                                                                                ) : null}
                                                                                            </>
                                                                                        );
                                                                                    }}
                                                                                </Field>
                                                                            </FormControl>
                                                                        </Grid>
                                                                        <span className="add-remove">
                                                                            <div className="addmore">
                                                                                {invoiceindex === invoiceList.length - 1 && (
                                                                                    <Button
                                                                                        variant="outlined"
                                                                                        color="primary"
                                                                                        className="txt-capitalize"
                                                                                        onClick={() => {
                                                                                            push({
                                                                                                particulars: '',
                                                                                                amount: '',
                                                                                                description: '',
                                                                                            });
                                                                                        }}
                                                                                        disabled={usertype === "Other employee users"}
                                                                                    >
                                                                                        Add More
                                                                                    </Button>
                                                                                )}
                                                                            </div>
                                                                            <div className="removemore">
                                                                                {invoiceList.length !== 1 && (
                                                                                    <Button
                                                                                        variant="outlined"
                                                                                        color="primary"
                                                                                        className="txt-capitalize "
                                                                                        onClick={() => {
                                                                                            remove(invoiceindex);
                                                                                        }}
                                                                                        disabled={usertype === "Other employee users"}


                                                                                    >
                                                                                        Remove
                                                                                    </Button>
                                                                                )}
                                                                            </div>
                                                                        </span>
                                                                    </Fragment>
                                                                );
                                                            })}
                                                        </>
                                                    );
                                                }}
                                            </FieldArray>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>

                            <div className="footer-button">
                                <ul>
                                    <li>
                                        <Button
                                            color="primary"
                                            className="buttonnext txt-cap"
                                            onClick={() => navigateBack()}
                                        >  Back
                                        </Button>
                                    </li>
                                    <li>
                                        <Button
                                            color="primary"
                                            className="buttonnext txt-cap"
                                            type="submit"
                                            disabled={usertype === "Other employee users"}

                                        >
                                            Submit
                                        </Button>
                                    </li>
                                </ul>
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
}
